var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94922 13.136C7.94922 14.3185 8.85672 15.2718 9.98422 15.2718H12.2851C13.2659 15.2718 14.0634 14.4377 14.0634 13.411C14.0634 12.2927 13.5776 11.8985 12.8534 11.6418L9.15922 10.3585C8.43505 10.1018 7.94922 9.70768 7.94922 8.58935C7.94922 7.56268 8.74672 6.72852 9.72755 6.72852H12.0284C13.1559 6.72852 14.0634 7.68185 14.0634 8.86435",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5V16.5",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 20.1673C16.0625 20.1673 20.1666 16.0633 20.1666 11.0007C20.1666 5.93804 16.0625 1.83398 10.9999 1.83398C5.93731 1.83398 1.83325 5.93804 1.83325 11.0007C1.83325 16.0633 5.93731 20.1673 10.9999 20.1673Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircle);
export default __webpack_public_path__ + "static/media/dollar-circle.0ed5427bb25f01bb4c651306576b5833.svg";
export { ForwardRef as ReactComponent };